import { createFileRoute, redirect } from '@tanstack/react-router'
import { getAccessToken, getIdToken } from '@/utils/token-storage'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: () => {
    // Check if user is authenticated
    const accessToken = getAccessToken()
    const idToken = getIdToken()

    if (!accessToken || !idToken) {
      // Redirect to login if not authenticated
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: window.location.pathname,
        },
      })
    }
  },
  component: AuthenticatedLayout,
})
